import { IntlTFunc } from 'next-intl';

import { BreadcrumbsItem, Categories } from '../types';

type Category = {
  name?: string | null;
  url?: string | null;
} | null;

export const getFirstLevelCategory = (categories: Categories) => {
  return categories.reduce(
    (min, item) =>
      item?.level && item.level <= (min?.level ?? 0) ? item : min,
    categories[0]
  );
};

export const getLastLevelCategory = (categories: Categories) => {
  return categories.reduce(
    (max, item) => (item?.level && item.level > (max?.level ?? 0) ? item : max),
    categories[categories.length - 1]
  );
};

const mapCategory = (category?: Category): BreadcrumbsItem => ({
  label: category?.name ?? '',
  href: category?.url ? `/${category.url}` : ''
});

export const breadcrumbsMapper = (
  name: string,
  lastLevelCategory: Categories[0] | null,
  t: IntlTFunc,
  productUrl?: string
): BreadcrumbsItem[] => {
  const home = { label: t('HomePage'), href: '/' };
  const product = { label: name, href: productUrl || '' };

  if (!lastLevelCategory || !lastLevelCategory.breadcrumbs)
    return [home, product];

  const crumbs = lastLevelCategory.breadcrumbs.map(mapCategory) ?? [];

  crumbs.push(mapCategory(lastLevelCategory));

  return [home, ...crumbs, product];
};
